import { ToggleButton } from '@mui/material'
import colors from 'styles/colors'

const StyledToggleButton = ({ value, children, sx = {}, ...otherProps }) => {
  return (
    <ToggleButton
      value={value}
      style={{
        borderRadius: 100
      }}
      sx={{
        padding: '12px 16px',
        border: `1px solid ${colors.Grey300} !important`,
        backgroundColor: colors.White,
        '&.Mui-selected': {
          border: `2px solid ${colors.GoldenYellow400} !important`,
          backgroundColor: colors.GoldenYellow50,
          boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.20)'
        },
        '&.Mui-selected:hover': {
          backgroundColor: colors.GoldenYellow50
        },
        ...sx
      }}
      {...otherProps}>
      {children}
    </ToggleButton>
  )
}

export default StyledToggleButton
